<template>
  <div :class="$style.container">
    <div :class="$style.content">

      <div :class="$style.logo">
        <img :src="getLogoLink" alt="" />
      </div>

      <div v-show="loader" :class="$style.loader">
        <base-loader />
      </div>

      <div>
        <div ref="bubble" :class="$style.bubble">
          <div
            :class="$style.text"
            v-text="$t('bill.payed.title')"
          />
          <img
            :class="$style.image"
            src="@/assets/images/festive-confetti.gif"
            alt=""
          />
        </div>

        <div v-if="isInternalOrigin" :class="$style.button">
          <!-- TODO: возможно стоит удалить этот харкод и получать хост из переменных окружения -->
          <link-button href="https://my.capusta.space/bill">
            {{ $t('bill.payed.button') }}
          </link-button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import BaseLoader from 'atoms/base/BaseLoader';
import LinkButton from 'molecules/common/LinkButton';

export default {
  name: 'BillPayed',
  components: {
    BaseLoader,
    LinkButton,
  },
  created() {
    this.loader = true;
  },
  mounted() {
    this.$refs.bubble.addEventListener('animationstart', this.hideLoader);
  },
  beforeDestroy() {
    this.$refs.bubble.removeEventListener('animationstart', this.hideLoader);
  },
  data() {
    return {
      loader: false,
    };
  },
  computed: {
    ...mapGetters([
      'getLogoLink',
      'isInternalOrigin',
    ]),
  },
  methods: {
    hideLoader() {
      this.loader = false;
    },
  },
};
</script>

<style lang="sass" module>
  .container
    +flexbox
    +justify-content(center)
    +size(100vw, 100vh)
    padding: 60px 0

    +respond-to(small)
      +align-items(center)

  .content
    +flexbox
    +flex-direction(column)
    +align-items(center)
    position: relative

    +respond-to(small)
      +flex-direction(row)

  .logo
    flex: none
    width: 120px
    height: 82px
    margin: 0 0 30px 0

    +respond-to(small)
      margin: 0 26px 66px 0

  .loader
    position: absolute
    left: calc(50% - 20.5px)
    top: 128px

    +respond-to(small)
      left: 160px
      top: 16px

  .bubble
    +flexbox
    +justify-content(space-between)
    +align-items(center)
    +size(270px, auto)
    margin-bottom: 30px
    padding: 6px 15px
    background-color: var(--color-white)
    border-radius: 0 8px 8px 8px
    box-shadow: 0px 1px 2px rgba(189, 189, 189, 0.5)
    transform: scale(0.9)
    transform-origin: right top
    animation: bubble-enter 1s cubic-bezier(0.19, 1, 0.22, 1) 2s forwards
    opacity: 0

  .text
    +font-type(semi-bold, 24, 24)
    padding-left: 50px
    color: var(--color-black-2)
    white-space: nowrap
    overflow: hidden
    animation: text-enter 1s cubic-bezier(0.19, 1, 0.22, 1) 2s forwards

  .image
    +size(60px)

    img
      width: 100%

  .button
    max-width: 200px
    margin: 0 auto
    transform: translateY(100px)
    animation: button-enter 1s cubic-bezier(0.19, 1, 0.22, 1) 3s forwards
    opacity: 0

    +respond-to(small)
      margin: 0

    a
      +font-type(medium, 16, 18)

  @keyframes bubble-enter
    0%
      opacity: 0
      transform: scale(0.9)
    100%
      opacity: 1
      transform: scale(1)

  @keyframes text-enter
    0%
      padding-left: 50px
    100%
      padding-left: 0

  @keyframes button-enter
    0%
      opacity: 0
      transform: translateY(100px)
    100%
      opacity: 1
      transform: translateY(0)
</style>
